import React, { FC } from 'react';

import { Money as MoneyModel } from 'api-client';
import { Information, Money } from 'components/common/utils';

import styles from '../AccountDetails.module.scss';

type StatItem =
  { label: string; money: MoneyModel } | { label: string; value: string; tooltip?: string };

type Props = {
  stats: StatItem[];
  className?: string;
};

export const AccountStatsCard: FC<Props> = ({ stats, className }) => (
  <div className={`${styles.statsCard} ${className ?? ''}`}>
    <div className={styles.statsGrid}>
      {stats.map((stat, idx) => (
        <React.Fragment key={stat.label}>
          <div className={styles.statItem}>
            <div className={styles.statLabel}>
              {stat.label}
              {'tooltip' in stat && stat.tooltip ? (
                <span className={styles.statTooltip}>
                  <Information position={'left'}>{stat.tooltip}</Information>
                </span>
              ) : null}
            </div>
            <div className={styles.statValue}>
              {'money' in stat ? <Money money={stat.money} /> : stat.value}
            </div>
          </div>
          {idx < stats.length - 1 && <div className={styles.statDivider} />}
        </React.Fragment>
      ))}
    </div>
  </div>
);
